import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[espAgreementNoFormat]',
  standalone: true,
})
export class EspAgreementNoFormatDirective {
  private _control = inject(NgControl);

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length > 6) {
      value = value.slice(0, 6);
    }

    if (value.length > 4) {
      value = `${value.slice(0, 4)}-${value.slice(4)}`;
    }

    this._control.control?.setValue(value, { emitEvent: false });
  }
}
